import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ZodiacTheme } from './zodiacThemes';
interface CreditsTabProps {
  theme: ZodiacTheme;
  onNavigate: (page: string) => void;
}
export function CreditsTab({
  theme,
  onNavigate
}: CreditsTabProps) {
  return <div className="space-y-6" data-id="element-15871">
      <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-15872">
        Кредиты и Пакеты
      </h2>
      <Card padding="lg" className={`bg-gradient-to-r ${theme.gradient} text-white border-none mb-8 shadow-lg`} data-id="element-15873">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-15874">
          <div data-id="element-15875">
            <div className="text-white/80 text-sm mb-1" data-id="element-15876">Доступный баланс</div>
            <div className="text-4xl font-bold flex items-baseline" data-id="element-15877">
              2{' '}
              <span className="text-xl font-normal text-white/80 ml-2" data-id="element-15878">
                кредита
              </span>
            </div>
            <p className="text-sm text-white/80 mt-2" data-id="element-15879">
              1 кредит = 1 любой авто-отчёт. Кредиты не сгорают.
            </p>
          </div>
          <Button variant="outline" size="lg" className="bg-white text-slate-900 border-none hover:bg-slate-100" onClick={() => onNavigate('pricing')} data-id="element-15880">
            Купить пакет
          </Button>
        </div>
      </Card>

      <h3 className="font-bold text-slate-900 mb-4" data-id="element-15881">История операций</h3>
      <Card padding="none" className="overflow-hidden" data-id="element-15882">
        <table className="w-full text-left text-sm" data-id="element-15883">
          <thead className="bg-slate-50 text-slate-500" data-id="element-15884">
            <tr data-id="element-15885">
              <th className="px-6 py-4 font-medium" data-id="element-15886">Дата</th>
              <th className="px-6 py-4 font-medium" data-id="element-15887">Операция</th>
              <th className="px-6 py-4 font-medium text-right" data-id="element-15888">Изменение</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-15889">
            <tr data-id="element-15890">
              <td className="px-6 py-4 text-slate-600" data-id="element-15891">12 Окт 2024</td>
              <td className="px-6 py-4 font-medium text-slate-900" data-id="element-15892">
                Оплата авто-отчёта "Натальная карта"
              </td>
              <td className="px-6 py-4 text-right text-rose-600 font-medium" data-id="element-15893">
                -1 кредит
              </td>
            </tr>
            <tr data-id="element-15894">
              <td className="px-6 py-4 text-slate-600" data-id="element-15895">10 Окт 2024</td>
              <td className="px-6 py-4 font-medium text-slate-900" data-id="element-15896">
                Покупка пакета "3 отчёта"
              </td>
              <td className="px-6 py-4 text-right text-emerald-600 font-medium" data-id="element-15897">
                +3 кредита
              </td>
            </tr>
          </tbody>
        </table>
      </Card>
    </div>;
}